/* script */
//
//
//
//
//
//
//

// Components
import TemplateForm from 'ui/components/wizards/create-template/TemplateForm.vue';

// Utils
import { isArray, set } from 'lodash';

/**
 * This component is used to create a new template.
 *
 * It uses a structure of a `Popup` to guide the user through the creation process.
 *
 * @category ui.pages.settings
 * @exports TemplateSettings
 * @component
 */
const __vue_script__ = {
    name: 'TemplateSettings',

    components: {
        TemplateForm
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            editMode: true,
            postUploadUrl: '',
            uploadNodeId: '',
            startUpload: null,
            loading: false,
            template: null,
            ready: false
        };
    },

    created() {
        this.load();
    },

    methods: {
        async load() {
            try {
                this.ready = false;
                this.template = await this.$services.event.getEvent(this.params.event._id);
            } catch (error) {
                console.error('[] Could not load template details', error.message);
            } finally {
                this.$nextTick(() => this.ready = true);
            }
        },

        /**
         * Saves the template settings
         */
        async save() {
            try {
                const valid = await this.$refs.editor.validate();
                if (!valid) return;
                this.loading = true;

                await this.$refs.editor.saveSubforms();

                // @ts-ignore
                const { form } = this.$refs.editor;

                set(form, 'description.category', form.category);
                set(form, 'description.categories', form.categories);
                delete form.category;
                delete form.categories;

                const result = await this.$services.template.save(form);

                if (result) {
                    await this.uploadImages(form.screenshots, form.app_icon);
                    this.notifySuccess();
                }

                await this.load();

            } catch (error) {
                console.error('[TemplateSettings] Could not edit template\'s settings');
                this.$services.crashReporting.captureException(error);
                this.notifyFailure();
            } finally {
                this.loading = false;
            }
        },

        /**
         * Uploads app icon and screenshots
         *
         * @param {File[]} screenshots the screenshots to upload to the template
         * @param {File[]} appIcon the app icon to upload to the template
         */
        async uploadImages(screenshots, appIcon) {
            const { id, node } = this.template;
            const hasScreenshot = Object.values(screenshots).filter(i => i && typeof i !== 'string');
            if (hasScreenshot) {
                await this.$services.template.uploadImages(screenshots, id);
                console.info('[TemplateSettings] Screenshots upload completed');
            }
            const hasIcon = isArray(appIcon) && typeof appIcon[0] !== 'string';
            if (hasIcon) {
                await this.$services.event.uploadAppIcon(appIcon[0], id, node);
                console.info('[CreateTemplate] App icon upload completed');
            }
        },

        /**
         * Deletes the specified image from the template
         *
         * @param {String} filename the filename of image to delete
         */
        async deleteImage(filename) {
            try {
                await this.$services.template.deleteImage(filename, this.template.id);
                this.notifySuccess();
            } catch (error) {
                this.notifyFailure();
            }
        },

        /**
         * Sends a 'success' notification
         */
        notifySuccess() {
            this.$notify({
                group: 'flashes',
                text: this.$i18n.t('templates.settings.save_success').toString(),
                type: 'success',
            });

        },

        /**
         * Sends a 'error' notification
         */
        notifyFailure() {
            this.$notify({
                group: 'flashes',
                text: this.$i18n.t('templates.settings.save_failure').toString(),
                type: 'error',
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-settings" },
    [
      _vm.ready
        ? _c("template-form", {
            ref: "editor",
            attrs: {
              params: {
                form: _vm.template,
                currentController: _vm.params.currentController,
              },
            },
            on: { "image:removed": _vm.deleteImage },
          })
        : _vm._e(),
      _c("secondary-toolbar", [
        _c(
          "button",
          {
            staticClass: "btn primary",
            attrs: { disabled: _vm.loading },
            on: {
              click: function ($event) {
                return _vm.save()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("templates.settings.save")))]
        ),
      ]),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/settings/TemplateSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__